import { Router, Route } from "react-router-dom";
import { history } from "./_helpers/history";
import { Layout } from "./_components/Layout/Layout";
import { AddReclamation } from "./Feedback/AddReclamation";
import { Answer } from "./Feedback/Answer";
import plMessages from "./pl.json";
import { locale, loadMessages } from "devextreme/localization";

const App = () => {
  locale("pl");
  loadMessages(plMessages);
  return (
    <>
      <Router history={history}>
        <Layout>
          <Route path="/" exact component={AddReclamation} />
          <Route path="/answer" component={Answer} />
        </Layout>
      </Router>
    </>
  );
};

export default App;
